import { ActivityModel } from '../models/activity.model';

export class ActivityLocationLookup {
    public Activity: ActivityModel;
    public Location: any;

    constructor(activityLocationLookup: ActivityLocationLookup) {
        this.Activity = activityLocationLookup.Activity;
        this.Location = activityLocationLookup.Location;
    }
}